import { createSlice } from '@reduxjs/toolkit';
import { createReducerNames } from '../../../core/helpers/default';

const name = 'customMethodsList';

const reducersKeys = {
  getDataRequest: 'getDataRequest',
  getDataSuccess: 'getDataSuccess',
  getDataFailure: 'getDataFailure',
  deleteItemRequest: 'deleteItemRequest',
  deleteItemRSuccess: 'deleteItemRSuccess',
  deleteItemRFailure: 'deleteItemRFailure',
};

const initialState = {
  data: [],
  meta: {},
  loaded: false,
  loading: false,
  error: null,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    [reducersKeys.getDataRequest]: (state) => {
      state.loading = true;
      state.loaded = false;
      state.payout = null;
    },
    [reducersKeys.getDataSuccess]: (state, { payload }) => {
      state.data = payload.data;
      state.meta = payload.meta;
      state.loading = false;
      state.loaded = true;
    },
    [reducersKeys.getDataFailure]: (state, { payload }) => {
      state.loading = false;
      state.loaded = true;
      state.error = payload.error;
    },
    [reducersKeys.deleteItemRequest]: (state) => {
      state.loading = true;
      state.payout = null;
    },
    [reducersKeys.deleteItemRSuccess]: (state, { payload }) => {
      state.data = state.data.filter((i) => (i.id !== payload.deletedId));
      state.loading = false;
    },
    [reducersKeys.deleteItemRFailure]: (state, { payload }) => {
      state.loading = false;
      state.error = payload.error;
    },
  },
});

export const categoriesListReducers = createReducerNames(name, reducersKeys);
export const { actions } = slice;

export default slice.reducer;
